// forEach pollyfill
if (typeof NodeList.prototype.forEach !== "function") {
    NodeList.prototype.forEach = Array.prototype.forEach;
}

// Could be designed to be extendable but we just need something simple
// that works for now.
// Keep everything out of global scope
(() => {
    const subMenus = document.querySelectorAll(".has-submenu");
    let trigger_selector = "trigger";
    let active_selector = "mobile";
    let element = document.querySelector("body");
    let triggers = document.querySelectorAll(`.${trigger_selector}`);

    function toggle_class(el, sel) {
        el.classList.contains(sel)
            ? el.classList.remove(sel)
            : el.classList.add(sel);
    }

    if (triggers) {
        triggers = [...triggers];

        triggers.map(t => {
            t.addEventListener("click", () => {
                toggle_class(element, active_selector);
            });
        });
    }

    if (subMenus) {
        subMenus.forEach(subMenu => {
            subMenu.addEventListener("click", () => {
                toggle_class(subMenu, "active");
            });
        });
    }
})();
